import React from "react";

const CostDetailsModal = React.memo(({ isOpen, onClose, messages, totalPrice, t }) => {
    if (!isOpen) return null;

    // Extract cost details
    let mainQuestionCost = 0;
    let chatsTotalCost = 0;
    const subQuestions = [];
    const regenerations = [];

    let isFirstBot = true;
    (messages || []).forEach((msg) => {
        if (msg.sender === "bot") {
            const price = parseFloat(msg.price) || 0;
            if (isFirstBot) {
                mainQuestionCost = price;
                isFirstBot = false;
            } else {
                chatsTotalCost += price;
                // Find preceding user message for title
                let userText = "";
                const msgIndex = messages.indexOf(msg);
                for (let j = msgIndex - 1; j >= 0; j--) {
                    if (messages[j].sender === "user") {
                        userText = messages[j].text;
                        break;
                    }
                }
                if (!userText) {
                    userText = t("Pages.Chatbot.SubQuestion") || "سؤال فرعي";
                }
                subQuestions.push({
                    title: userText,
                    price: price
                });
            }

            // Extract regenerations
            if (msg.regenerations && Array.isArray(msg.regenerations)) {
                msg.regenerations.forEach((r) => {
                    regenerations.push({
                        count: r.count,
                        price: parseFloat(r.price) || 0
                    });
                });
            }
        }
    });

    return (
        <div className="cost-modal-overlay" onClick={onClose}>
            <div className="cost-modal-card animate__animated animate__zoomIn animate__faster" onClick={(e) => e.stopPropagation()}>
                <div className="cost-modal-header d-flex justify-content-between align-items-center">
                    <h4 className="cost-modal-title m-0">
                        <i className="fal fa-file-invoice-dollar ml-2"></i>
                        {t("Pages.Chatbot.TotalCostDetails") || "تفاصيل تكلفة المحادثة"}
                    </h4>
                    <button type="button" className="cost-modal-close-btn" onClick={onClose}>
                        <i className="fal fa-times"></i>
                    </button>
                </div>
                <div className="cost-modal-body">
                    <div className="cost-detail-item">
                        <span className="cost-detail-label">
                            {t("Pages.Chatbot.PriceItemMainQuestion") || "النص المولّد (السؤال الرئيسي)"}:
                        </span>
                        <span className="cost-detail-val font-weight-bold">
                            {mainQuestionCost.toFixed(5)}$
                        </span>
                    </div>
                    <div className="cost-detail-item">
                        <span className="cost-detail-label">
                            {t("Pages.Chatbot.PriceItemChats") || "المحادثات"}:
                        </span>
                        <span className="cost-detail-val font-weight-bold">
                            {chatsTotalCost.toFixed(5)}$
                        </span>
                    </div>
                    {subQuestions.length > 0 && (
                        <ul className="cost-sub-list">
                            {subQuestions.map((sq, index) => (
                                <li key={index} className="cost-sub-item">
                                    <span className="cost-sub-title text-truncate">{sq.title}:</span>
                                    <span className="cost-sub-val">{sq.price.toFixed(5)}$</span>
                                </li>
                            ))}
                        </ul>
                    )}
                    {regenerations.length > 0 && (
                        <div className="cost-regenerations-section mt-2 pt-2 border-top">
                            <span className="cost-detail-label font-weight-bold d-block mb-1 text-right" style={{ fontSize: "13.5px", color: "#0e2c53" }}>
                                {t("Pages.Chatbot.RegeneratedQuestionsCost") || "إعادة توليد الأسئلة"}:
                            </span>
                            <ul className="cost-sub-list pr-0" style={{ listStyleType: "none", padding: 0 }}>
                                {regenerations.map((reg, index) => (
                                    <li key={index} className="cost-sub-item d-flex justify-content-between align-items-center py-1" style={{ fontSize: "13px", color: "#555" }}>
                                        <span className="cost-sub-title">
                                            #{index + 1} {t("Pages.Chatbot.RegeneratedQuestionsItem", { count: reg.count }) || `إعادة توليد الأسئلة (${reg.count} سؤال)`}
                                        </span>
                                        <span className="cost-sub-val font-weight-bold">{reg.price.toFixed(5)}$</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    )}
                    <div className="cost-modal-divider"></div>
                    <div className="cost-detail-item total-row">
                        <span className="cost-detail-label font-weight-bold">
                            {t("Pages.Chatbot.Total") || "الإجمالي"}:
                        </span>
                        <span className="cost-detail-val total-val font-weight-bold text-success">
                            {totalPrice.toFixed(5)}$
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
});

export default CostDetailsModal;
